import React from "react";

const badgePalette = {
  Compliant: "bg-emerald-100 text-emerald-700 border-emerald-200",
  notCompliant: "bg-red-100 text-red-700 border-red-200",
  Due: "bg-amber-100 text-amber-700 border-amber-200",
  notDue: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Excluded: "bg-gray-100 text-gray-600 border-gray-200",
};

const StatusBadge = ({ label, colorOverride }) => {
  if (!label) return null;
  const palette =
    colorOverride || badgePalette[label] || "bg-slate-100 text-slate-700";
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-0.5 text-xs font-semibold ${palette}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
